import React, { Component } from 'react';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { Container } from 'reactstrap';

import {
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav
} from '@coreui/react';
// sidebar nav and routes config
import { navigation, routes } from '../../config';

import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import { compose } from 'recompose';
import { connect } from 'react-redux';

import Loading from '../../components/Loading';
import { some } from 'lodash';

import { currentPage } from '../../redux/actions/PaginationActions/currentPage';

class DefaultLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps) {
    let currentLocation = this.props.location.pathname.split('/')[1];
    let previousLocation = prevProps.location.pathname.split('/')[1];
    if (currentLocation !== previousLocation) {
      this.props.dispatch(currentPage(1));
    }
  }

  render() {
    const user = this.props;
    return (
      <div className='app'>
        {user.authUser != null && (
          <AppHeader fixed>
            <DefaultHeader />
          </AppHeader>
        )}
        <div className='app-body'>
          {user.authUser != null && (
            <AppSidebar fixed display='lg'>
              <AppSidebarHeader />
              <AppSidebarForm />
              <AppSidebarNav navConfig={navigation} {...this.props} />
              <AppSidebarFooter />
              <AppSidebarMinimizer />
            </AppSidebar>
          )}
          <main className='main'>
            <ToastContainer />
            <Loading isLoading={this.props.isLoading} />
            {user.authUser != null && <AppBreadcrumb appRoutes={routes} />}
            <Container fluid>
              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={(props) => <route.component {...props} />}
                    />
                  ) : null;
                })}
                <Redirect from='/' to='/dashboard' />
              </Switch>
            </Container>
          </main>
          {user.authUser != null && (
            <AppAside fixed hidden>
              <DefaultAside />
            </AppAside>
          )}
        </div>
        {user.authUser != null && (
          <AppFooter>
            <DefaultFooter />
          </AppFooter>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.sessionState.authUser,
    isLoading: some(state, (item) => item.submitted === true)
  };
}

const composedObj = compose(connect(mapStateToProps))(DefaultLayout);

export default withRouter(composedObj);



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js